__turbopack_context__.v({
  "rotate360": "_2_X51q_rotate360",
  "spinner": "_2_X51q_spinner",
});
